<template>
  <section v-if="open" class="footer-box">
    <div class="footer-box-content">
      <span class="highlight">Esse website utiliza cookies. Usamos cookies para personalizar conteúdos e fornecer recursos de mídia social para publicidades e análises, que podem combiná-las com outras informações que você forneceu utilizando nossos serviços. Você concorda com nossos cookies se continuar a usar nosso site.</span>
      <button @click="accept" type="button" class="button-accept">Concordo</button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Lgpd',
  data () {
    return {
      open: false
    }
  },
  async mounted () {
    if (!process.env.CORDOVA_PLATFORM && !localStorage.getItem('swsslg')) this.open = true
  },
  methods: {
    accept () {
      localStorage.setItem('swsslg', 'true')
      this.open = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables.scss";

.footer-box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(#180e51, #13073A);
  z-index: 99;
}

.footer-box-content {
  display: inline-block;
  align-items: center;
  max-width: 1000px;
  margin: 0 auto;
  padding: 15px 25px;
}

.highlight {
  color: $light-color;
  font-weight: 500;
}

.button-accept {
  color: #fff;
  border: none;
  border-radius: 100px;
  background-image: linear-gradient(to bottom right, $light-color, $light-color);
  font-size: 1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 25px;
  margin-left: 20px;
  display: block;
  cursor: pointer;
  margin: auto;
  &:focus {
    outline: 0;
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .footer-box-content {
    display: flex;
  }
  .button-accept {
    display: block;
    margin-left: 10px;
  }
}

</style>
